/**
 * This function works like a `deepmerge` function, but it will also call `onFallback`
 * with the path to the property that was not found in the primary object, by replacing
 * all non-object values with getters on their parent object that will call `onFallback`
 * when they are accessed, and return the fallback value.
 */
export function createTokenFallback(primary, fallback, onFallback = () => {
    /* noop */
}, path = []) {
    const mergedObject = {};
    const keys = [
        ...new Set([...Object.keys(primary), ...Object.keys(fallback)]),
    ];
    for (const key of keys) {
        if (typeof key === "symbol" || typeof key === "number") {
            continue;
        }
        const primaryValue = primary[key];
        const fallbackValue = fallback[key];
        if (primaryValue &&
            typeof primaryValue === "object" &&
            !Array.isArray(primaryValue) &&
            fallbackValue &&
            typeof fallbackValue === "object" &&
            !Array.isArray(fallbackValue)) {
            // @ts-expect-error We know this is an object
            mergedObject[key] = createTokenFallback(primaryValue, fallbackValue, onFallback, [...path, key]);
        }
        else if (typeof primaryValue !== "undefined") {
            // @ts-expect-error We know this is an object
            mergedObject[key] = primaryValue;
        }
        else if (typeof fallbackValue !== "undefined") {
            Object.defineProperty(mergedObject, key, {
                get() {
                    onFallback === null || onFallback === void 0 ? void 0 : onFallback([...path, key]);
                    return fallbackValue;
                },
            });
        }
    }
    return mergedObject;
}
//# sourceMappingURL=tokenFallback.js.map